export default class Country {

  id = null;

  name = '';
  alpha2 = '';
  alpha3 = '';
  timezone = '';

  constructor() {
  }
}